import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
// token 持久化兜底：sessionStorage 被清空时从 localStorage 恢复
let token = sessionStorage.getItem("token") || localStorage.getItem("token") || '';
if (token && !sessionStorage.getItem("token")) {
  sessionStorage.setItem("token", token);
}

let appInfo = JSON.parse(localStorage.getItem('appInfo')) || {};
let messageNum = token ? localStorage.getItem("messageNum") || 0 : 0;

export default new Vuex.Store({
  //state存放状态,
  state: {
    userInfo,
    token,
    messageNum,
    appInfo,
    bannerList: [],
    hotList: [],
    recentList: [],
    favoriteList: [],
    realbetList: [],
    jokerList: [],
    gamingList: [],
    sportList: [],
    lotteryList: [],
    conciseList: [],
    tiyuList: [],
  },
  //getter为state的计算属性
  getters: {

  },
  //mutations可更改状态的逻辑，同步操作
  mutations: {
    changGameList(state) {
      let bannerList = localStorage.getItem('bannerList') ? JSON.parse(localStorage.getItem('bannerList')) : [];
      state.bannerList = bannerList;

      let hotList = localStorage.getItem('hotList') ? JSON.parse(localStorage.getItem('hotList')) : [];
      state.hotList = hotList;

      let recentList = localStorage.getItem('recentList') ? JSON.parse(localStorage.getItem('recentList')) : [];
      state.recentList = recentList;

      let favoriteList = localStorage.getItem('favoriteList') ? JSON.parse(localStorage.getItem('favoriteList')) : [];
      state.favoriteList = favoriteList;

      let realbetListStr = localStorage.getItem('realbetList');
      let realbetList = realbetListStr ? JSON.parse(realbetListStr) : [];
      state.realbetList = realbetList;

      let jokerList = localStorage.getItem('jokerList') ? JSON.parse(localStorage.getItem('jokerList')) : [];
      state.jokerList = jokerList;
      let gamingList = localStorage.getItem('gamingList') ? JSON.parse(localStorage.getItem('gamingList')) : [];
      state.gamingList = gamingList;
      let sportList = localStorage.getItem('sportList') ? JSON.parse(localStorage.getItem('sportList')) : [];
      state.sportList = sportList;
      let lotteryList = localStorage.getItem('lotteryList') ? JSON.parse(localStorage.getItem('lotteryList')) : [];
      state.lotteryList = lotteryList;
      let conciseList = localStorage.getItem('conciseList') ? JSON.parse(localStorage.getItem('conciseList')) : [];
      state.conciseList = conciseList;

      let tiyuList = localStorage.getItem('tiyuList') ? JSON.parse(localStorage.getItem('tiyuList')) : [];
      state.tiyuList = tiyuList;

    },
    changUserInfo(state) {
      let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      state.userInfo = userInfo;
    },
    changToken(state) {
      state.token = sessionStorage.getItem('token') || localStorage.getItem('token') || '';
    }
    , changMessageNum(state) {
      let show = localStorage.getItem('show');
      state.messageNum = show ? 0 : localStorage.getItem('messageNum');
    }
    , changappInfo(state) {
      let appInfo = JSON.parse(localStorage.getItem('appInfo'))
      state.appInfo = appInfo;
    },
    // 只更新收藏列表（不重置 hotList 等其他列表，避免收藏图标闪回）
    setFavoriteList(state, list) {
      state.favoriteList = Array.isArray(list) ? list : [];
    },
    setRecentList(state, list) {
      state.recentList = Array.isArray(list) ? list : [];
    },
  },
  //提交mutation，异步操作
  actions: {

  },
  // 将store模块化
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js